'use client';

import { createContext } from 'react';

import type { Draft } from 'immer';
import type { BehaviorSubject } from 'rxjs';

import type { ChatSession } from '../../types/ChatSession';
import type { ChatSessionType } from '../../types/ChatSessionType';

export interface SessionListStatus {
  isRefreshing: boolean;
  isLoading: boolean;
  error: Error | undefined;
  isCached: boolean;
}

export interface ChatSessionContextValue {
  sessionType$: BehaviorSubject<ChatSessionType>;
  status$: BehaviorSubject<SessionListStatus>;
  sessions$: BehaviorSubject<Map<ChatSessionType, ChatSession[]>>;
  updateSessions: (
    type: ChatSessionType,
    recipe: (draft: Draft<ChatSession[]>) => void,
  ) => void;
  loadSessions: (
    type: ChatSessionType,
    options?: { refresh?: boolean },
  ) => Promise<void>;
}

export const ChatSessionContext = createContext<ChatSessionContextValue | null>(
  null,
);
